// Utilities for local-date journal keys shared with the Android app.

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

function toLocalDate(date) {
  if (typeof date === 'string' && ISO_DATE_RE.test(date)) {
    const [year, month, day] = date.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  const value = date?.toDate ? date.toDate() : new Date(date);
  if (Number.isNaN(value.getTime())) {
    throw new Error(`Invalid journal date: ${date}`);
  }
  return value;
}

export function entryIdForDate(date) {
  if (typeof date === 'string' && ISO_DATE_RE.test(date)) {
    return date;
  }

  const value = toLocalDate(date);
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function startOfLocalDay(date) {
  const value = toLocalDate(date);
  return new Date(value.getFullYear(), value.getMonth(), value.getDate());
}

export function startOfNextLocalDay(date) {
  const start = startOfLocalDay(date);
  return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1);
}
